import React, {  } from 'react';
import {
    ProfileContainer, ProfileForm, FormContent, Heading, Subheading, InfoTab, UserIcon, CalendarIcon, Info, PhoneIcon, LocationIcon, FieldGroup,
} from './Profile.styles';
import { ActionButtonGroup, AddressInput, BackButton, EditButton, PhoneInput, SuiteInput } from './components';
import { useProfileHook } from './hooks';
import { useHistory } from 'react-router';

const Profile: React.FunctionComponent = () => 
{
    const history = useHistory();

    const goBack = () => history.push('/dashboard');

    const {
        currentUser, phoneEditMode, addressEditMode, enablePhoneEditMode, enableAddressEditMode, disableEditMode, phoneNumber,
        handlePhoneChange, savePhoneNumber, fullAddress, handleAddressChange, handleAddressSelect, saveAddress, suiteNumber,
        handleSuiteChange
    } = useProfileHook();

    return (
        <ProfileContainer>
            <ProfileForm>
                <BackButton goBack={goBack} />
                <FormContent>
                    <Heading>Hi, {currentUser?.first_name}</Heading>
                    <Subheading>Welcome Back! Your privacy is important to us, so we keep your information safe and secured</Subheading>
                    <InfoTab>
                        <UserIcon />
                        <Info>{currentUser?.fullname}</Info>
                    </InfoTab>
                    <InfoTab>
                        <CalendarIcon />
                        <Info>{currentUser?.dob}</Info>
                    </InfoTab>
                    <InfoTab editMode={phoneEditMode}>
                        <PhoneIcon />
                        {phoneEditMode
                            ? <PhoneInput value={phoneNumber} handlePhoneChange={handlePhoneChange} />
                            : <Info>{phoneNumber}</Info>}
                        {phoneEditMode
                            ? <ActionButtonGroup onSave={savePhoneNumber} onClose={disableEditMode} />
                            : <EditButton onClick={enablePhoneEditMode} />}
                    </InfoTab>
                    <InfoTab editMode={addressEditMode} addressTab>
                        <LocationIcon />
                        {addressEditMode
                            ? (
                                <FieldGroup>
                                    <AddressInput value={fullAddress} onChange={handleAddressChange} onSelect={handleAddressSelect} />
                                    <SuiteInput suite={suiteNumber} onChange={handleSuiteChange} />
                                </FieldGroup>
                            )
                            : <Info>{fullAddress}</Info>}
                        {addressEditMode
                            ? <ActionButtonGroup onSave={saveAddress} onClose={disableEditMode} />
                            : <EditButton onClick={enableAddressEditMode} />}
                    </InfoTab>
                </FormContent>
            </ProfileForm>
        </ProfileContainer>
    );
};

export default Profile;
